import { tariffBuyCustomTitle } from 'reactApp/appHelpers/featuresHelpers';
import { MultiSessionDeviceSubs } from 'reactApp/appHelpers/featuresHelpers/features/multiSessionSubscriptions';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { useBuyTitle } from 'reactApp/ui/TariffBuy/useBuyTitle';
import { getPeriodName } from 'reactApp/utils/Period';
import { computersGenitive } from 'reactApp/utils/pluralHelpers';
import { formatPrice } from 'reactApp/utils/priceHelpers';

import type { BuyIframeQueryParams } from './Buy';

const { title: titleFromQuery }: BuyIframeQueryParams = getQueryParams();

export const useTitle = ({ isPhone, product, isWebview }) => {
    const buyTitle = useBuyTitle({
        product,
        isMobile: isWebview || isPhone,
    });

    if (titleFromQuery && tariffBuyCustomTitle?.hasOwnProperty(titleFromQuery)) {
        return tariffBuyCustomTitle[titleFromQuery];
    }

    /* tempexp_20439-start */
    if (product?.id && MultiSessionDeviceSubs.enabled) {
        const devices = MultiSessionDeviceSubs.getDeviceCount(product.id);
        if (MultiSessionDeviceSubs.isFreeChoiceProduct(product.id)) {
            return `Вход в\u00A0Почту с\u00A0${devices}\u00A0${computersGenitive(devices)} на\u00A0${getPeriodName(product.period)}`;
        }
        if (MultiSessionDeviceSubs.isPresetInSubsProdcut(product.id)) {
            return `Mail\u00A0Space Для\u00A0работы и\u00A0вход в Почту с ${devices} ${computersGenitive(devices)} на\u00A0${getPeriodName(
                product.period
            )}`;
        }
    }
    /* tempexp_20439-end */

    // для облачного вебвью возвращает title как в старом окне
    if (isWebview && buyTitle) {
        return buyTitle;
    }

    if (isPhone && product) {
        const { discountPrice, discountPeriod, period, space, price, hasTrial, trialPeriod } = product || {};

        const priceText = hasTrial ? 'бесплатно' : ` за ${formatPrice(discountPrice || price)} ₽`;

        return `Отключение рекламы\nи ${space.value} на ${getPeriodName(
            trialPeriod || discountPeriod || period,
            false,
            true
        )} ${priceText}`;
    }

    return 'Никакой рекламы и больше места в Почте и Облаке';
};
